export default __webpack_public_path__ + "static/media/a-team-title-bg.d8e222fc.svg";